import { formatUtcInTimezone } from './dateUtils';

/**
 * Returns true if a UTC date/time slot is in the past or within 4 hours from now.
 * timeStr is UTC (from guide-availability), so UTC hours are used for comparison.
 */
export const isTimeTooSoon = (dateStr: string, timeStr: string): boolean => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  const slotDateTime = new Date(dateStr + 'T00:00:00Z');
  slotDateTime.setUTCHours(hours, minutes, 0, 0);

  const now = new Date();
  const fourHoursFromNow = new Date(now.getTime() + 4 * 60 * 60 * 1000);

  return slotDateTime <= fourHoursFromNow;
};

/**
 * Convert a UTC time string (HH:mm) + date (YYYY-MM-DD) to the seeker's local timezone.
 * Returns the original utcTime if no timezone is provided or conversion fails.
 */
export const convertUtcToSeekerTime = (
  utcTime: string,
  date: string,
  seekerTimezone: string | null
): string => {
  if (!seekerTimezone) {
    return utcTime;
  }

  try {
    const utcTimestamp = `${date}T${utcTime}:00Z`;
    return formatUtcInTimezone(utcTimestamp, seekerTimezone, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch (error) {
    console.error('Error converting UTC to seeker time:', error);
    return utcTime;
  }
};
